import Home from '@/components/home/home'
import Index from '@/components/index/index'
import Hall from '@/components/hall/hall'
import ReHall from '@/components/rehall/rehall'
import OverHall from '@/components/overhall/overhall'
import Detail from '@/components/detail/detail'
import Sellpage from '@/components/sellpage/sellpage'
import Recoverpage from '@/components/recoverpage/recoverpage'
import Evaluatepage from '@/components/evaluatepage/evaluatepage'
import Helpcenter from '@/components/helpcenter/helpcenter'
import User from '@/components/user/user'
import UserIndex from '@/components/userindex/userindex'
import Login from '@/components/login/login'
import Register from '@/components/register/register'
import Information from '@/components/information/information'
import Password from '@/components/information/password/password'
import Buylist from '@/components/record/buylist'
import Selllist from '@/components/record/selllist'
import Message from '@/components/message/message'
import DetailM from '@/components/message/detailM'
import Upload from '@/components/upload/upload'
import Explain from '@/components/common/explain/explain'

export default
  [
    { // 首页
      path: '/',
      component: Home,
      children: [
        {
          // 首页
          path: '',
          name: 'index',
          component: Index
        },
        {
          path: 'hall',
          name: 'hall',
          component: Hall
        },
        {
          path: 'rehall',
          name: 'rehall',
          component: ReHall
        },
        {
          path: 'overhall',
          name: 'overhall',
          component: OverHall
        },
        {
          path: 'hall/:id',
          name: 'detail',
          component: Detail
        },
        {
          path: 'rehall/:id',
          name: 'detailr',
          component: Detail
        },
        {
          path: 'sellpage',
          name: 'sellpage',
          component: Sellpage
        },
        {
          path: 'recoverpage',
          name: 'recoverpage',
          component: Recoverpage
        },
        {
          path: 'evaluatepage',
          name: 'evaluatepage',
          component: Evaluatepage
        },
        {
          path: 'helpcenter',
          name: 'helpcenter',
          component: Helpcenter
        }
      ]
    },
    {
      // 登录
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      // 注册
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      // 用户中心
      path: '/user',
      component: UserIndex,
      children: [
        {
          // 用户中心首页
          path: '',
          name: 'user',
          component: User
        },
        {
          // 用户信息
          path: 'information',
          name: 'information',
          component: Information,
          meta: {
            requireAuth: true
          }
        },
        {
          // 修改密码
          path: 'password',
          name: 'password',
          component: Password,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'buylist',
          name: 'buylist',
          component: Buylist,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'selllist',
          name: 'selllist',
          component: Selllist,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'message',
          name: 'message',
          component: Message,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'detailM',
          name: 'detailM',
          component: DetailM,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'upload',
          name: 'upload',
          component: Upload,
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      // 说明规则
      path: '/explain',
      name: 'explain',
      component: Explain
    },
    {
      path: '*',
      // component: NotFound,
      name: 'notfound',
      meta: {
        title: '404-页面丢了'
      },
      redirect: '/'
    }
  ]



// WEBPACK FOOTER //
// ./src/router/index.js